module.exports = __webpack_public_path__ + "img/KSC02996.273f0b83.jpg";